import { Box, Tag } from '@factorialco/deprecated-design-system'
import { TrainingsSessionScheduleEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  mode?: TrainingsSessionScheduleEnum | null
}

export const ModeTag = ({ mode }: Props) => {
  const text =
    mode === 'selfpaced'
      ? i18n.t('trainings.my_trainings_revamp.session_detail.self_paced')
      : i18n.t('trainings.my_trainings_revamp.session_detail.scheduled')

  const icon = mode === 'selfpaced' ? 'trainings' : 'clock'
  const type = mode === 'selfpaced' ? 'purple' : 'grey5'

  return (
    <Box width="fit-content">
      <Tag solid iconColor={'lighter920'} icon={icon} leftItem="icon" type={type}>
        {text}
      </Tag>
    </Box>
  )
}
